import { IncidentRepository } from '../../domain/repositories/IncidentRepository';

export class CompleteDataEntry {
    constructor(private repository: IncidentRepository) {}

    async execute(claimRequestKey: string, releaseClaimRequest: boolean) {
        await this.repository.completeDataEntry(claimRequestKey, releaseClaimRequest);
    }
}
